import React, {useContext} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import { FirebaseContext } from '../../Services/firebase'

export default function Day(props) {

    const data = {
        date: '',
        entreeA: '',
        platA: '',
        laitageA: '',
        dessertA: '',
        entreeB: '',
        platB: '',
        laitageB: '',
        dessertB: '',
        entreeD: '',
        platD: '',
        laitageD: '',
        dessertD: '',
        entreeH: '',
        platH: '',
        laitageH: '',
        dessertH: '',
        entreeSS: '',
        platSS: '',
        laitageSS: '',
        dessertSS: '',
        entreeSV: '',
        platSV: '',
        laitageSV: '',
        dessertSV: '',
        entreeSP: '',
        platSP: '',
        laitageSP: '',
        dessertSP: '',
        potage: '',
        brick: 'Velouté en brique',
        diner: ''
    }

    const firebase = useContext(FirebaseContext)

    const [MenuData, setMenuData] = React.useState(data);

    const checkValues = MenuData.date !== '' &&
                        MenuData.entreeA !== '' &&
                        MenuData.platA !== '' &&
                        MenuData.laitageA !== '' &&
                        MenuData.dessertA !== '' &&
                        MenuData.entreeD !== '' &&
                        MenuData.platD !== '' &&
                        MenuData.laitageD !== '' &&
                        MenuData.dessertD !== '' &&
                        MenuData.entreeH !== '' &&
                        MenuData.platH !== '' &&
                        MenuData.laitageH !== '' &&
                        MenuData.dessertH !== '' &&
                        MenuData.entreeSS !== '' &&
                        MenuData.platSS !== '' &&
                        MenuData.laitageSS !== '' &&
                        MenuData.dessertSS !== '' &&
                        MenuData.entreeSV !== '' &&
                        MenuData.platSV !== '' &&
                        MenuData.laitageSV !== '' &&
                        MenuData.dessertSV !== '' &&
                        MenuData.entreeSP !== '' &&
                        MenuData.platSP !== '' &&
                        MenuData.laitageSP !== '' &&
                        MenuData.dessertSP !== '' &&
                        MenuData.potage !== '' &&
                        MenuData.diner !== ''

    const handleChange = e => {
        setMenuData({...MenuData, [e.target.id]: e.target.value})
        console.log(MenuData.date)
    }

    return (
        <div style={{display: "flex", flexDirection: "column", width: "70vw"}}>
            <TextField id="date" label="date" type="date" value={MenuData.date} sx={{ width: 220 }} InputLabelProps={{shrink: true,}} onChange={handleChange} size="small"/>
            <h4>Menu A</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeA" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeA} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platA" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platA} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageA" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageA} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertA" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertA} onChange={handleChange}/>
            </div>
            <h4>Menu B</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeB" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeB} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platB" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platB} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageB" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageB} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertB" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertB} onChange={handleChange}/>
            </div>
            <h4>Menu diabétique</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeD" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeD} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platD" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platD} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageD" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageD} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertD" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertD} onChange={handleChange}/>
            </div>
            <h4>Menu haché</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeH" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeH} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platH" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platH} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageH" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageH} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertH" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertH} onChange={handleChange}/>
            </div>
            <h4>Menu sans sel</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeSS" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeSS} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platSS" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platSS} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageSS" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageSS} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertSS" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertSS} onChange={handleChange}/>
            </div>
            <h4>Menu sans viande</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeSV" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeSV} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platSV" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platSV} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageSV" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageSV} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertSV" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertSV} onChange={handleChange}/>
            </div>
            <h4>Menu sans poisson</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeSP" label="Entrée" sx={{ width: 300}} size="small" value={MenuData.entreeSP} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platSP" label="Plat" sx={{ width: 300}} size="small" value={MenuData.platSP} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageSP" label="Laitage" sx={{ width: 300}} size="small" value={MenuData.laitageSP} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertSP" label="Dessert" sx={{ width: 300}} size="small" value={MenuData.dessertSP} onChange={handleChange}/>
            </div>
            <h4>Potage</h4>
            <div style={{display: "flex"}}>
                <TextField id="potage" label="Potage" sx={{ width: 300}} size="small" value={MenuData.potage} onChange={handleChange}/>
            </div>
            <h4>Diner léger</h4>
            <div style={{display: "flex"}}>
                <TextField id="diner" label="Diner léger" sx={{ width: 300}} size="small" value={MenuData.diner} onChange={handleChange}/>
            </div>
            <Button disabled={!checkValues} variant="contained" endIcon={<SaveAltIcon />} style={{marginTop: "1vh", width: "10vw"}} onClick={saveDay}>Sauvegarder</Button>
        </div>
    )
    function saveDay() {
        try {
            firebase.newDay(props.uid, props.week, props.day, MenuData)
            .then(
                alert('Le menu de ce jour a bien été enregistré')
            )
            .catch(error => {
                alert(error.message)
            })
        }catch(err) {
            alert(err)
        }
    }
}